export const progressTabs = [
  {
    name: "tracking",
    label: "Tracking",
  },
  {
    name: "reports",
    label: "Reports",
  },
  {
    name: "proofOfDelivery",
    label: "Proof of Delivery",
  },
];

export const sortReportOptions = [
  {
    value: "PickupDate",
    label: "Pickup Date",
    hint: "(Shows only those packages picked up)",
  },
  {
    value: "PrintedDate",
    label: "Printed Date",
    hint: "(Shows all packages)",
  },
  {
    value: "BillingRef",
    label: "Billing Reference",
    hint: "(Shows only those packages picked up)",
  },
];

export const typeReportOptions = [
  {
    value: "UserShip",
    label: "My Shipments",
    hint: "",
  },
  {
    value: "AccntShip",
    label: "All Shipments on my Account",
  },
  {
    value: "All_AND_3rdPartyShip",
    label: "My Shipments",
    hint: "(Including 3rd Party Billed)",
  },
];

export const trackingViews = {
  trackingForm: "tracking-form",
  trackingResults: "tracking-results",
};
export const podViews = {
  form: "form",
  table: "table",
};
